'use client';

import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { cn } from '../../helpers/classes';

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    trackClassName?: string;
    rangeClassName?: string;
    thumbClassName?: string;
    ariaValueText?: string;
    ariaLabelThumb?: string;
    ariaLabelRoot?: string;
  }
>(
  (
    {
      className,
      trackClassName,
      rangeClassName,
      thumbClassName,
      ariaValueText,
      ariaLabelRoot,
      ariaLabelThumb,
      ...props
    },
    ref,
  ) => (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        'relative flex w-full touch-none select-none items-center',
        className,
      )}
      aria-label={ariaLabelRoot}
      {...props}
    >
      <SliderPrimitive.Track
        className={cn(
          `relative h-1.5 w-full grow overflow-hidden rounded-full bg-slate-500/30 dark:bg-slate-300/20`,
          trackClassName,
        )}
      >
        <SliderPrimitive.Range
          className={cn(
            'absolute h-full bg-slate-500 dark:bg-slate-300',
            rangeClassName,
          )}
        />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className={cn(
          `focus-visible:ring-ring block h-[13px] w-[13px] rounded-full border border-slate-500 bg-slate-500 shadow transition-colors focus-visible:outline-none focus-visible:ring-1 disabled:pointer-events-none disabled:opacity-50 dark:border-slate-300 dark:bg-slate-300`,
          thumbClassName,
        )}
        aria-label={ariaLabelThumb}
        aria-valuetext={ariaValueText}
        aria-valuemin={props.min}
        aria-valuemax={props.max}
        aria-valuenow={props.value?.[0] ?? 0}
        aria-orientation={props.orientation}
      />
    </SliderPrimitive.Root>
  ),
);
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
